import React, { useEffect, useState } from "react";
import api, { daysAgo, ymd } from "../api";
import "../App.css";

const Stats = () => {
  const [from, setFrom] = useState(ymd(daysAgo(29)));
  const [to, setTo] = useState(ymd(new Date()));
  const [data, setData] = useState({ daily: [], reasons: [], totals: { total: 0, success: 0, fail: 0, pending: 0 } });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const res = await api.get("/ui/stats", { params: { from, to } });
      setData(res.data);
    } catch (e) { /* 그대로 둔다 */ } finally { setBusy(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const max = Math.max(1, ...data.daily.map((d) => d.total));
  const rate = data.totals.total
    ? ((data.totals.success / data.totals.total) * 100).toFixed(1)
    : "-";

  return (
    <div className="stats">
      <h2 className="title">통계</h2>

      <div className="filter card">
        <div className="row">
          <input className="input" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          <span className="tilde">~</span>
          <input className="input" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
          <button className="btn primary" onClick={load} disabled={busy}>{busy ? "계산 중…" : "조회"}</button>
        </div>
      </div>

      <div className="summary big">
        <div className="s all"><b>{data.totals.total.toLocaleString()}</b><span>보낸 건수</span></div>
        <div className="s ok"><b>{data.totals.success.toLocaleString()}</b><span>도착</span></div>
        <div className="s bad"><b>{data.totals.fail.toLocaleString()}</b><span>실패</span></div>
        <div className="s rate"><b>{rate}%</b><span>도착률</span></div>
      </div>

      <section className="card">
        <div className="card-head"><span>날짜별 발송량</span></div>
        <div className="chart">
          {data.daily.map((d) => (
            <div className="bar-wrap" key={d.d} title={`${d.d} · 총 ${d.total} / 실패 ${d.fail}`}>
              <div className="bar">
                <div className="bar-fail" style={{ height: `${(d.fail / max) * 100}%` }} />
                <div className="bar-ok" style={{ height: `${((d.total - d.fail) / max) * 100}%` }} />
              </div>
              <span className="bar-label">{d.d.slice(6, 8)}</span>
            </div>
          ))}
          {!data.daily.length && <div className="empty">이 기간에 보낸 문자가 없습니다.</div>}
        </div>
      </section>

      <section className="card">
        <div className="card-head"><span>실패 사유</span></div>
        <table className="tbl">
          <thead><tr><th style={{ width: 80 }}>코드</th><th>사유</th><th style={{ width: 80 }}>건수</th></tr></thead>
          <tbody>
            {data.reasons.map((r) => (
              <tr key={r.code}><td>{r.code}</td><td>{r.reason}</td><td>{r.count}</td></tr>
            ))}
            {!data.reasons.length && <tr><td colSpan={3} className="empty">실패한 건이 없습니다.</td></tr>}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default Stats;
